var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * API service for the form-vs-corpus analysis (CZNA-478).
 *
 * Consumes `GET /czna-authorities/module-settings/analysis/{TYPE}`. Types mirror
 * the backend `FormAnalysis` record exactly.
 *
 * The response is computed live on every call — there is no snapshot table,
 * because the counts change on every record edit. Cost is dominated by the one
 * lopsided type: ~25 s for PERSONAL (986 038 records, 76% of the corpus) against
 * 1-5 s for every other type, so consumers must show a loading state that
 * survives half a minute.
 */
import { getHeaders } from './apiUtils';
import { API_PATHS } from '../types/apiPaths';
export var bucketOf = function (entry) {
    if (!entry.inData)
        return 'noDataBehindIt';
    return entry.inForm ? 'covered' : 'missingFromForm';
};
/** Share of the corpus carrying an entry, 0-100. Guards the empty-corpus divide. */
export var shareOfCorpus = function (entry, totalRecords) { return (totalRecords > 0 ? (entry.records / totalRecords) * 100 : 0); };
/** `046$f`, or a bare `005` for a control field. */
export var formatSlot = function (entry) { return (entry.subfield ? "".concat(entry.tag, "$").concat(entry.subfield) : entry.tag); };
/**
 * The server cancelled the analysis at its statement limit (CZNA-782). The
 * backend answers 504 with `{ code: "FORM_ANALYSIS_TIMEOUT", minutes }`; this is
 * that answer as an error the view can tell apart from every other failure, so
 * it can say the server stopped after that long rather than "could not be
 * computed". `minutes` is the server's, never a mirrored constant.
 */
var FormAnalysisTimeoutError = /** @class */ (function (_super) {
    __extends(FormAnalysisTimeoutError, _super);
    function FormAnalysisTimeoutError(minutes) {
        var _this = _super.call(this, "Form analysis was cancelled after ".concat(minutes, " minutes")) || this;
        _this.code = 'FORM_ANALYSIS_TIMEOUT';
        _this.name = 'FormAnalysisTimeoutError';
        _this.minutes = minutes;
        return _this;
    }
    return FormAnalysisTimeoutError;
}(Error));
export { FormAnalysisTimeoutError };
/**
 * Type guard for the view. **Brand check, deliberately not `instanceof`**: the
 * stripes build compiles this class to ES5, where `instanceof
 * FormAnalysisTimeoutError` is false in the browser and true in jest — the
 * mechanism is written down once, in `customErrorInstanceofGate.test.ts`.
 */
export var isFormAnalysisTimeoutError = function (error) {
    return typeof error === 'object'
        && error !== null
        && error.code === 'FORM_ANALYSIS_TIMEOUT'
        && typeof error.minutes === 'number';
};
var isErrorWithResponse = function (error) {
    var _a;
    return typeof error === 'object'
        && error !== null
        && 'response' in error
        && typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.json) === 'function';
};
/**
 * Reads a failed request as the statement-timeout answer, or returns null for
 * anything else — a 504 from the gateway itself carries no such body and must
 * stay a generic failure rather than be blamed on the analysis.
 */
var parseFormAnalysisTimeout = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var body, source, _a, _b, code, minutes;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!isErrorWithResponse(error) || error.response.status !== 504) {
                    return [2 /*return*/, null];
                }
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                source = error.response.clone ? error.response.clone() : error.response;
                return [4 /*yield*/, source.json()];
            case 2:
                body = _c.sent();
                return [3 /*break*/, 4];
            case 3:
                _a = _c.sent();
                return [2 /*return*/, null];
            case 4:
                _b = (body !== null && body !== void 0 ? body : {}), code = _b.code, minutes = _b.minutes;
                return [2 /*return*/, code === 'FORM_ANALYSIS_TIMEOUT' && typeof minutes === 'number'
                        ? new FormAnalysisTimeoutError(minutes)
                        : null];
        }
    });
}); };
/**
 * Fetches the analysis, or `null` while the backend is still computing it.
 *
 * The endpoint is asynchronous (CZNA-508): the first call starts a background
 * pass over the corpus and answers **202 with no body**; later calls answer 200
 * once the result is held. `null` means "ask again shortly", which is what
 * `useFormAnalysis` turns into a poll.
 *
 * No `timeout` override, deliberately. The 30 s stripes default is right again
 * now that every request is short — raising it was the earlier fix for this bug
 * and it could not have held: Kong's `read_timeout` on the test cluster is 60 s,
 * so a request that outlives that is cut off by the gateway no matter what the
 * browser was willing to wait. Polling removes the ceiling instead of arguing
 * with it.
 */
export var fetchFormAnalysis = function (ky, type) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1, timeout;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 4]);
                return [4 /*yield*/, ky.get("".concat(API_PATHS.CZNA_MODULE_SETTINGS_ANALYSIS, "/").concat(type), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.status === 202 ? null : response.json()];
            case 2:
                error_1 = _a.sent();
                return [4 /*yield*/, parseFormAnalysisTimeout(error_1)];
            case 3:
                timeout = _a.sent();
                if (timeout)
                    throw timeout;
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Discards the held result and starts a fresh pass. Answers 202; the caller
 * polls the GET as usual. A refresh while one is already running is a no-op on
 * the backend rather than a second pass over a million records.
 */
export var refreshFormAnalysis = function (ky, type) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.post("".concat(API_PATHS.CZNA_MODULE_SETTINGS_ANALYSIS, "/").concat(type, "/refresh"), { headers: getHeaders() })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
